<template>
	<div class="wr">
		<router-view :key="pID"></router-view>
	</div>
</template>

<script>
import { selectProjectId } from '@/store/modules/selectedProject/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';
export default {
	name: 'Projects',
	props: {
		pID: { type: [Number, String], required: true },
	},
	methods: {
		...mapActionsShorthand({ selectProjectId }),
	},
	watch: {
		pID: {
			handler(newV) {
				this.selectProjectId({ id: newV });
			},
			immediate: true,
		},
	},
	beforeDestroy() {
		this.selectProjectId({ id: null });
	},
};
</script>

<style scoped>
.wr {
	position: relative;
	width: 100%;
	height: 100%;
}
.kit_list {
	width: 342px;
	position: relative;
	border: 1px solid #d3dae9 !important;
	border-top-width: 0px !important;
}
.mdA .kit_list {
	width: 280px;
}
</style>
